<template>
  <!-- Modal -->
  <div>

    <!-- Modal Ver Eventos en X fecha -->
    <div>
      <div class="modal fade" id="menuCalendarOptions" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h6 v-if="current.current_day" class="modal-title" id="exampleModalLongTitle"
                style="font-size: 16px; color: #6b819b;">
                Eventos de la fecha
                <br>
                {{ current.current_day }} de {{ month }}
              </h6>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="element-box">
              <div class="invoice-table text-center">
                <table class="table-hover text-center">
                  <tbody class="text-center" v-for="det in eventos_actuales" :key="det.id">
                    <tr v-bind:style="det == detalle
                      ? 'background-color: #c9d6e5;'
                      : 'background-color: #f2f8ff;'
                      " @click="OpenSlideOpt(det)">
                      <td style="width: 600px; padding: 10px" class="text-left">
                        <div class="row">
                          <div class="col-6 text-left" style="margin-bottom: -10px!important;">
                            <p class="font-weight-bold text-success">
                              {{ userTiendas.find(t => t.tienda.codigo == det.tienda).tienda.nombre || "Tienda No Encontrada" }}
                            </p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-6 text-left">
                            <p class="font-weight-bold">
                              {{ tipoEvento[det.tipo] || det.tipo }}
                            </p>
                          </div>
                          <div class="col-6 text-right">
                            <p class="font-weight-bold text-dark">
                              ID - {{ det.id.toLocaleString("en-GB") }}
                            </p>
                          </div>
                        </div>
                        <span>{{ det.proveedor_obj.codigo }} -
                          {{ det.proveedor_obj.nombre }}</span>
                        <br>
                        <span>{{ det.fecha_de | moment("hh:mm a") }}</span>
                        -
                        <span>{{ det.fecha_a | moment("hh:mm a") }}</span>
                        <br>
                        <div class="row mt-2">
                          <div class="col-12">
                            <span v-if="det.estado == 'A'" class="badge badge-secondary" style="float: right;">
                              <i class="fas fa-hourglass-start"></i>&nbsp;
                              En espera
                            </span>
                            <span v-if="det.estado == '9'" class="badge badge-danger" style="float: right;">
                              <i class="fas fa-times"></i>&nbsp;
                              Evento cancelado
                            </span>
                            <span v-if="det.estado == 'E'" class="badge badge-blue" style="float: right;">
                              <i class="fas fa-history"></i>&nbsp;
                              En proceso
                            </span>
                            <span v-if="det.estado == 'C'" class="badge badge-success" style="float: right;">
                              <i class="fas fa-check"></i>&nbsp;
                              Evento finalizado
                            </span>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr style="animation: fade-in 1.5s 1" v-if="detalle == det">
                      <td>
                        <div v-if="det.estado == '9'">
                          <br>
                            <span class="text font-weight-bold" style="color: #6b819b;">
                              Motivo de Cancelación
                            </span>
                            <div class="row">
                              <div class="col-12">
                                <div class="btn btn-outline-danger disabled mt-1" style="border-radius: 25px;">
                                  <i class="fas fa-times"></i>&nbsp;
                                  {{ det.motivo_cancelacion_obj ? det.motivo_cancelacion_obj : "Desconocido" }}
                                </div>
                              </div>
                            </div>
                          <br>
                        </div>
                        <span class="text font-weight-bold" style="color: #6b819b;">Complementarios</span>
                        <br />
                        <br />
                        <div class="row text-center">
                          <div class="col-6">
                            <span class="text" style="color: #6b819b;">Tiempo Estimado</span> <br />
                            {{ detalle.estimacion_recepcion }}
                          </div>
                          <div class="col-6">
                            <span class="text" style="color: #6b819b;">Usuario</span> <br />
                            {{ detalle.usuario_obj.first_name }}
                            {{ detalle.usuario_obj.last_name }}
                          </div>
                        </div>
                        <br>
                        <hr>
                        <div class="btn-group col-12" v-if="det.estado == 'A'" role="group">
                          <button class="btn btn-dark w-100" type="button" disabled>
                            <i class="far fa-edit"></i>
                          </button>
                          <button 
                            v-if="current.fecha_actual < eventos_actuales[0].fecha_a"
                            class="btn btn-info w-100 position-relative" type="button" @click="añadirOC(det)"
                          >
                            <i class="far fa-file-alt"></i>
                          </button>
                          <button class="btn btn-danger w-100 position-relative" @click="cancelarAgenda(det)" >
                            <i class="fas fa-ban"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-if="eventos_actuales.length === 0">
                    <tr>
                      <td colspan="4" class="text-center text-muted"
                        style="font-style: italic; color: #b0b0b0; text-align: center;">
                        No hay eventos para este día
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="modal-footer">
              <button @click="addNewEvents()" class="btn btn-md btn-dark btn-block">
                Nuevo Evento <i class="fas fa-plus"></i>
              </button>
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                Cerrar <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- Modal Para Crear Nuevo Evento en Agenda -->
    <div class="modal fade" id="addCalendarEvents" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title text" style="color: #6b819b;" id="exampleModalLongTitle">
              Crear nuevo Evento
              <br>
              {{ current.current_day }} de {{ month }}
            </h6>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <TiendaSelectComponent 
                  :disabled="false" 
                  :current="current" 
                  :myprofile="true"
                />
              </div>
              <div class="col-md-12">
                <ProveedoresSelectComponent :current="current" />
              </div>
              <div class="col-7">
                <label>Tipo Evento:</label>
                <select style="padding: 0px" v-model="current.tipo" class="form-control">
                  <option value="R" selected>Recepción</option>
                  <option value="C">Cita</option>
                </select>
              </div>
              <div class="col-5">
                <label>Fecha Recep:</label>
                <br />
                <input v-model="current.date_select" type="date"
                  style="width: 100px; padding-left: 0px; padding-right: 0px" class="form-control-sm" />
              </div>
              <div class="col-6">
                <label>Hora Inicia</label> 
                <input v-model="current.hour_start" class="form-control" type="time" id="time-select" name="time"
                  min="05:00" max="20:00" />
                <small v-if="current.errors && current.errors.fecha_de">{{
                  current.errors.fecha_de
                  }}</small>
              </div>
              <div class="col-6">
                <label>Hora fin</label>
                <input v-model="current.hour_end" class="form-control" type="time" id="time-select" name="time"
                  min="05:00" max="20:00" />
                <small v-if="current.errors && current.errors.fecha_de">{{
                  current.errors.fecha_a
                  }}</small>
              </div>
              <div class="col-12">
                <label>Observaciones:</label>
                <textarea v-model="current.observaciones" class="form-control" type="text">
                </textarea>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button @click="agendarProveedor()" class="btn btn-dark">
              Crear <i class="fas fa-check"></i>
            </button>
            <button type="button" class="btn btn-danger" data-dismiss="modal" @click="CancelRec()">
              Cancelar <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    
    <!-- Modal añadir órdenes de compra -->
    <div class="modal fade" id="modalAddOC" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Órdenes de compra</h5>
            <button type="button" class="btn btn-danger" @click="cancelAddOC()"><i class="fas fa-times"></i></button>
          </div>
          <div class="col-12">
            <div v-if="eventoSeleccionado" class="col-12">
              <b>Evento:</b>
              <br>
              <b>{{ eventoSeleccionado.proveedor_obj.id }} - {{ eventoSeleccionado.proveedor_obj.nombre }}</b>
              <br>
              <b>{{ eventoSeleccionado.fecha_de | moment("hh:mm a") }} - {{
                eventoSeleccionado.fecha_a | moment("hh:mm a") }}
              </b>
            </div>
          </div>
          <div class="modal-body">
            <div class="input-group mb-3">
              <input type="text" class="form-control" placeholder="# Orden de Compra" v-model="orderCompraNumber">
              <div class="input-group-append">
                <button class="btn btn-dark" type="button" @click="buscarOrdenCompra">
                  <i class="fas fa-search"></i>
                </button>
              </div>
            </div>
            <div v-if="ordenesCompra.length">
              <div class="row ordencompra-table">
                <div class="col-12" v-for="orden in ordenesCompra" :key="orden.id">
                  <div class="card" style="background-color: #eaf3fc;">
                    <div class="card-body d-flex justify-content-between align-items-center">
                      <div>
                        <b class="card-title" style="font-size: 18px;">
                          #{{ orden.numero }}
                        </b>
                        <br>
                        <b style="font-size: 14px;">
                          {{ orden.proveedor.nombre }}
                        </b>
                        <p class="card-text">Tienda: {{ orden.tienda.nombre }}</p>
                        <p class="card-text">Fecha: {{ orden.fecha }}</p>
                      </div>
                      <button class="btn btn-dark btn-lg" @click="agregarOrdenCompra(orden)">
                        <i class="fas fa-plus"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="eventoSeleccionado && Array.isArray(eventoSeleccionado.apl_agenda_orden_compra)
              &&
              eventoSeleccionado.apl_agenda_orden_compra.length && agendaCargada">
              <hr>
              <h6>Órdenes de compra añadidas: {{ eventoSeleccionado.apl_agenda_orden_compra.length }}</h6>
              <div :class="{ 'anadidos-table': agendaCargada, 'anadidos-table loader-wrapper': !agendaCargada, }">
                <LoaderComponent :condicion="agendaCargada">
                </LoaderComponent>
                <div class="card" style="background-color: #f2e8f9;"
                  v-for="orden in eventoSeleccionado.apl_agenda_orden_compra" :key="orden.id">
                  <div class="card-body d-flex justify-content-between align-items-center">
                    <div>
                      <span style="font-size: 18px;">
                        <b>#{{ orden.orden_compra.numero }}</b>
                      </span>
                    </div>
                    <button class="btn btn-md btn-danger" style="float: right;"><i class="fas fa-minus"
                        @click="eliminarOrdenCompra(orden)"></i></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
import AgendaProveedoresService from "@/services/wms/AgendaProveedoresService";
import LoaderComponent from "@/components/commons/LoaderComponent.vue";
import CancelarEventoAgendaModal from "@/components/wms/agenda/CancelarEventoAgendaModal";
import CommonService from "@/services/commons/CommonService";

export default {
  provide() {
    return {
      refreshAgenda: this.refreshAgenda
    };
  },
  props: {
    refreshAllData: {
      type: Boolean,
    },
    eventos_actuales_children: {
      type: Array
    },
    tipoCancelacion: {
      type: Array
    },
    userTiendas: {
      type: Array
    },
    userTiendasCodes: {
      type: Array
    },
    day: {
      type: Number,
    },
    month: {
      type: String,
    },
  },
  components: {
    ProveedoresSelectComponent,
    TiendaSelectComponent,
    LoaderComponent,
    CancelarEventoAgendaModal
  },
  watch: {
    refreshAllData(newValue) {
      console.log("newValue", newValue);
      this.refreshAgenda();
      this.refreshAgendaChild();
    },
    day: function(val) {
      console.log("day()",val)
      if (this.day !== undefined && this.month !== undefined) {
        this.procesarFecha();
      }
      if (typeof val !== 'number' || isNaN(val)) {
        console.error("El valor de 'day' no es válido:", val);
        return;
      }
    },
    eventoSeleccionadoEliminarAPN(newValue) {
      this.$emit("dataEventoSeleccionadoEliminarEmitHijo", newValue);
    }
  },
  mounted() {
    this.getFechaActual();
    this.eventos_actuales = this.eventos_actuales_children;
  },
  computed: {
    monthInSpanish() {
      const monthsInSpanish = {
        "January": "Enero",
        "February": "Febrero",
        "March": "Marzo",
        "April": "Abril",
        "May": "Mayo",
        "June": "Junio",
        "July": "Julio",
        "August": "Agosto",
        "September": "Septiembre",
        "October": "Octubre",
        "November": "Noviembre",
        "December": "Diciembre"
      };
      return monthsInSpanish[this.month] || this.month;
    },
    updateEvento() {
      let self = this;
      if (self.agendaCargada && self.eventoSeleccionado) {
        let eventoActualizado = self.eventos_actuales.find(
          (evento) => evento.id === self.eventoSeleccionado.id
        );
        return eventoActualizado
      }
      return self.eventoSeleccionado

    },
  },
  data() {
    return {
      current: {
        current_day: "",
        fecha_actual: "",
        tienda: "",
        tipo: "R",
        errors: [],
      },
      detalle: "",
      eventoSeleccionadoEliminarAPN: null,
      eventos_actuales: [],
      tipoEvento: {
        R: "RECEPCIÓN",
        C: "CITA"
      },
      orderCompraNumber: "",
      ordenesCompra: [],
      isSearchAttempted: false,
      eventoSeleccionado: null,
      agendaCargada: false,
    };
  },
  methods: {
    getFechaActual() {
        this.current.fecha_actual = moment()
        .set({ hour: 0, minute: 0, second: 0 })
        .format("YYYY-MM-DD HH:mm:ss");
        console.log(this.current.fecha_actual);
    },
    procesarFecha() {
      if (typeof this.day !== 'number' || isNaN(this.day)) {
        console.error("El valor de 'day' no es válido:", this.day);
        return;
      }
      this.current.current_day = this.day;
      const spanishMonths = [
        "enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto",
        "septiembre", "octubre", "noviembre", "diciembre"
      ];
      const englishMonths = {
        "January": "enero", "February": "febrero", "March": "marzo", "April": "abril",
        "May": "mayo", "June": "junio", "July": "julio", "August": "agosto",
        "September": "septiembre", "October": "octubre", "November": "noviembre",
        "December": "diciembre"
      };
      let monthIndex = -1;
      const dateParts = this.month.match(/(\w+) (\d{4})/);
      if (dateParts) {
        const monthName = dateParts[1].toLowerCase();
        const year = dateParts[2];
        if (englishMonths[monthName.charAt(0).toUpperCase() + monthName.slice(1)]) {
          monthIndex = spanishMonths.indexOf(englishMonths[monthName.charAt(0).toUpperCase() + monthName.slice(1)]);
        } else {
          monthIndex = spanishMonths.indexOf(monthName);
        }
        if (monthIndex === -1) {
          console.error("El mes no es válido:", dateParts[1]);
          return;
        }
        this.current.date_select = new Date(year, monthIndex, this.current.current_day);
        if (isNaN(this.current.date_select)) {
          console.error("La fecha no es válida:", this.current.date_select);
          return;
        }
        this.current.date_select = moment(this.current.date_select).format("YYYY-MM-DD");
        this.current.fecha_de__gte = moment(this.current.date_select).set({ hour: 0, minute: 0, second: 0 }).format("YYYY-MM-DD HH:mm:ss");
        this.current.fecha_a__lte = moment(this.current.date_select).set({ hour: 23, minute: 59, second: 59 }).format("YYYY-MM-DD HH:mm:ss");
      } else {
        console.error("El formato de 'month' es incorrecto:", this.month);
      }
      this.refreshAgenda();
      this.refreshMystore();
    },
    refreshMystore() {
      let self = this;
      DynamicService.fetch("cat", "tienda-usuario", {
        myprofile: true,
      })
        .then((response) => {
          self.current.tienda = response.data.results[0].tienda.codigo;
          self.refreshAgendaChild();
        })
        .catch((error) => { });
    },
    agendarProveedor() {
      let self = this;
      if (!this.current.hour_start) {
        self.current.errors.hour_start = "Este campo es requerido";
        return;
      }
      if (!this.current.hour_end) {
        self.current.errors.hour_end = "Este campo es requerido";
        return;
      }
      let fecha_inicio = this.current.date_select + this.current.hour_start;
      let fecha_fin = this.current.date_select + this.current.hour_end;
      self.current.fecha_de = moment(fecha_inicio, "YYYY-MM-DD HH:mm");
      self.current.fecha_a = moment(fecha_fin, "YYYY-MM-DD HH:mm");
      self.current.fecha_de = this.current.fecha_de.format("YYYY-MM-DD HH:mm");
      self.current.fecha_a = this.current.fecha_a.format("YYYY-MM-DD HH:mm");
      let params = self.current;
      if (self.current.proveedor) {
        params.proveedor = self.current.proveedor.codigo;
      }
      DynamicService.save("wms", "agenda-proveedores", params)
        .then((response) => {
          $("#addCalendarEvents").modal("hide");
          $("#menuCalendarOptions").modal("show");
          self.refreshAgenda();
          self.refreshAgendaChild();
          self.refreshData();
          Notifications.alert.success("Agendar proveedor", "Realizado correctamente");
        })
        .catch((error) => {
          if (error.response.data.detail) {
            Notifications.alert.error("Agendar proveedor", error.response.data.detail);
          } else {
            self.current.errors = error.response.data;
          }
        });
    },
    refreshData() {
      let self = this;
      delete self.current.proveedor;
      self.current.observaciones = "";
      self.current.hour_start = "";
      self.current.hour_end = "";
      self.current.tipo = "R";
    },
    addNewEvents() {
      $("#menuCalendarOptions").modal("hide");
      $("#addCalendarEvents").modal("show");
    },
    OpenSlideOpt(det) {
      let self = this;
      if (self.detalle == det) {
        self.detalle = "";
        return;
      }
      self.detalle = det;
    },

    refreshAgendaChild() {
      let self = this;
      let params = {
        fecha_de__gte: this.current.fecha_de__gte,
        fecha_creacion: this.current.fecha_a__lte,
        fecha_a__lte: this.current.fecha_a__lte,
        tiendas: JSON.stringify(this.userTiendasCodes),
        quitar_paginacion: "true",
      }
      AgendaProveedoresService.fetch(params)
        .then((response) => {
          self.eventos_actuales = response.data;
          self.eventos_actuales_children = response.data;
          self.agendaCargada = true;
          self.eventoSeleccionado = self.updateEvento;
        })
        .catch((error) => {
          Notifications.alert.error("No se ha podido realizar la acción", error.response);
        });
    },
    
    guardar() {
      let self = this;
    },
    añadirOC(det) {
      let self = this;
      self.eventoSeleccionado = det;
      $("#menuCalendarOptions").modal("hide");
      $("#modalAddOC").modal("show");
    },

    buscarOrdenCompra() {
      if (this.orderCompraNumber.trim() === "") {
        Notifications.alert.error("Ingrese un número de orden de compra válida.");
        return;
      }
      this.isSearchAttempted = true;
      DynamicService.fetch("compras", "orden_compra_e", { numero: this.orderCompraNumber })
        .then((response) => {
          if (response.data.results && response.data.results.length > 0) {
            this.ordenesCompra = response.data.results;
          } else {
            this.ordenesCompra = [];
            Notifications.alert.warning("No se encontraron órdenes de compra", "Intenta con otro número.");
          }
        })
        .catch((error) => {
          Notifications.alert.error("Error al buscar la orden de compra", error.response);
        });
    },

    /**
     * Método que abre el modal de cancelacion de eventos pasados
     * dentro de los eventos en el modal de los días pasados.
     */
    cancelarAgenda(det) {
      let self = this;
      self.eventoSeleccionadoEliminarAPN = det;
      $("#menuCalendarOptions").modal("hide");
      $("#modalDeleteEvento").modal("show");
    },

    async agregarOrdenCompra(orden) {
      let self = this;
      await DynamicService.postAction(
        "wms",
        "agenda-proveedores",
        self.eventoSeleccionado.id,
        "agregar_orden_de_compra",
        {
          id: orden.id,
        }
      ).then((response) => {
        Notifications.toast.success("Orden de compra", "Se añadió correctamente.");
        self.agendaCargada = false;
        self.refreshAgendaChild();
        self.eventoSeleccionado = self.updateEvento;
        self.orderCompraNumber = "";
        self.ordenesCompra = [];
      })
        .catch((error) => {
          if (error.response.data.detail) {
            Notifications.toast.error("Error al agregar la orden de compra", error.response.data.detail);
          } else {
            self.current.errors = error.response.data;
          }
        });
    },
    
    eliminarOrdenCompra(orden) {
      let self = this;
      DynamicService.postAction(
        "wms",
        "agenda-proveedores",
        self.eventoSeleccionado.id,
        "eliminar_orden_de_compra",
        {
          id: orden.orden_compra.id,
        }
      ).then((response) => {
        Notifications.toast.success("¡Éxito!", "Se eliminó la orden de compra.");
        self.agendaCargada = false;
        self.refreshData();
        self.refreshAgendaChild();
      })
        .catch((error) => {
          if (error.response.data.detail) {
            Notifications.toast.error("No se pudo eliminar la orden de compra", error.response.data.detail);
          } else {
            self.current.errors = error.response.data;
          }
        });
    },
    CancelRec() {
      let self = this;
      self.refreshData();
      $("#addCalendarEvents").modal("hide");
      $("#menuCalendarOptions").modal("show");
    },
    cancelAddOC() {
      this.ordenesCompra = [];
      this.orderCompraNumber = "";
      $("#modalAddOC").modal("hide");
      $("#menuCalendarOptions").modal("show");
    },
  },
};
</script>
<style scoped>
.center {
  margin-left: 40px;
  margin-top: 10px;
}

.select-size {
  width: 345px;
  height: 24px;
}

.time-size {
  width: 115px;
  height: 24px;
}

.item {
  display: inline;
  width: 100%;
  height: 24px;
}

.invoice-table {
  max-height: 400px;
  overflow-y: auto;
}

.ordencompra-table {
  max-height: 170px;
  overflow-y: auto;
}

.anadidos-table {
  max-height: 193px;
  overflow-y: auto;
}

.badge {
  font-size: 11px;
  padding: 1px 11px;
  border-radius: 12px;
  text-transform: capitalize;
  height: 13px;
  width: 130px;
}
</style>
